import {
  useControlledNavigationSequenceControl,
  useNavigateToErrorField,
} from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';
import { useEffect } from 'react';

import type { IFormHeader } from 'shared/types';

import { useFormTriggerWhenFormForcedOpen } from './useFormTriggerWhenFormForcedOpen';

type TUseCommonFormBodyHooks = {
  isFormForceOpened: boolean | undefined;
  currentControls: IFieldConfiguration[];
  headerData?: IFormHeader;
  setHeader?: ((newHeader: IFormHeader) => void) | undefined;
};

export const useCommonFormBodyHooks = ({
  isFormForceOpened,
  currentControls,
  headerData,
  setHeader,
}: TUseCommonFormBodyHooks) => {
  useFormTriggerWhenFormForcedOpen(isFormForceOpened);

  const controls = useControlledNavigationSequenceControl({ fields: currentControls });

  useNavigateToErrorField();

  const { subtitle, icon, title } = headerData || {};

  useEffect(() => {
    if (subtitle || icon || title) {
      setHeader?.({ title, icon, subtitle });
    }
  }, [subtitle, icon, setHeader, title]);

  return { controls };
};
